import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import ObtieneDatosCookies from '../tools/obtieneDatosCookiesUsuario';

const GeneraPaseSalidaGrupalForm = ({ cadetes, promocionId, onClose }) => {

    const Usuario = ObtieneDatosCookies();
//     console.log(promocionId);

    // Nuevo estado para manejar el estado de carga
    const [isLoading, setIsLoading] = useState(false);

    const formatISOToLocal = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16);
    };

    const [formData, setFormData] = useState({
        fechaHoraSalida: formatISOToLocal(new Date().toISOString()),
        fechaHoraRegreso: "",
        cadetesDni: [],
        promocionId: promocionId,
        dependenciaAutorizanteId: Usuario.destino,
        usuarioAutorizanteId: Usuario.identificacion,
        sede: Usuario.sedeID == 2 ? "Rosario" : "Recreo",
        tipo: "",
        observacion: "",
        estado: "Pendiente",
    });

    useEffect(() => {
        if (cadetes && cadetes.length > 0) {
            const dnis = cadetes.map(cadete => cadete.cadeteDni);
            setFormData(prevFormData => ({
                ...prevFormData,
                cadetesDni: dnis
            }));
        }
    }, [cadetes]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevFormData) => {
            let newFormData = { ...prevFormData, [name]: value };

            if (name === "fechaHoraSalida") {
                const salida = new Date(value);
                const regreso = new Date(prevFormData.fechaHoraRegreso);

                if (!prevFormData.fechaHoraRegreso || regreso <= salida) {
                    salida.setHours(salida.getHours() + 1);
                    newFormData.fechaHoraRegreso = salida.toISOString().slice(0, 16);
                }
            }
            return newFormData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Salir si ya hay una petición en curso
        if (isLoading) {
            return;
        }

        const salida = new Date(formData.fechaHoraSalida);
        const regreso = new Date(formData.fechaHoraRegreso);

        if (regreso <= salida) {
            Swal.fire({
                title: "Error en las fechas",
                text: "La fecha y hora de regreso debe ser posterior a la de salida.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return;
        }

        // Validar que se hayan seleccionado cadetes para generar el pase grupal
        if (formData.cadetesDni.length === 0) {
            Swal.fire({
                title: "Error",
                text: "Debe seleccionar al menos un cadete para generar el pase grupal.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        // Activar el estado de carga
        setIsLoading(true);

        try {
            const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
            const client = axios.create({
                baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/creaPaseDeSalidaGrupal`,
                headers: {
                    Authorization: `Basic ${token}`,
                },
            });
//             console.log(`${process.env.REACT_APP_BASEURL}NCadetes/creaPaseDeSalidaGrupal`);

            const response = await client.post('/', formData);
            const data = response.data; // Almacenamos la respuesta para un manejo más fácil

            // --- Lógica de manejo de respuesta del backend modificada ---
            if (data.success) { // Esto significa que AL MENOS UN pase se creó
                let successMessage = data.message; // El backend ya construye el mensaje completo
                let iconType = "success"; 

                // Si el backend indicó que algunos no se crearon, es una advertencia
                if (data.dnisNoCreados && data.dnisNoCreados.length > 0) {
                    iconType = "warning"; 
                }

                Swal.fire({
                    title: "Operación Completada", 
                    text: successMessage,
                    icon: iconType,
                    confirmButtonText: "OK",
                }).then(() => onClose());

            } else { // Esto ocurre si NINGÚN pase pudo ser creado (data.success es false)
                // En este caso, el mensaje del backend ya debe ser suficientemente descriptivo
                const errorMessage = data.message || "Error desconocido al crear los pases.";

                Swal.fire({
                    title: "Error al generar pases",
                    text: errorMessage, // Usamos el mensaje del backend directamente
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
            // --- Fin de lógica de manejo de respuesta ---

        } catch (error) {
            Swal.fire({
                title: "Error de Conexión",
                text: "Falló la comunicación con el servidor. Intente de nuevo.",
                icon: "error",
                confirmButtonText: "OK",
            });
            console.error('Error al enviar los datos:', error);
        } finally {
            // Desactivar el estado de carga siempre, sin importar el resultado
            setIsLoading(false);
            onClose()
        }
    };

    return (
        <div style={{ maxHeight: "500px", width: "450px", overflow: "auto", margin: "0 auto" }}>
            <form onSubmit={handleSubmit}>
                <div className="" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

                    <div className="col-md-8 mb-3">
                        <label className="form-label"><strong>Cadetes a Incluir:</strong></label>
                        <div style={{ maxHeight: '100px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
                            {formData.cadetesDni.length > 0 ? (
                                formData.cadetesDni.map(dni => (
                                    <span key={dni} className="badge bg-secondary me-1 mb-1">{dni}</span>
                                ))
                            ) : (
                                <p>No hay cadetes seleccionados.</p>
                            )}
                        </div>
                    </div>

                    <div className="col-md-8">
                        <label htmlFor="fechaHoraSalida" className="form-label">Fecha y Hora de Salida</label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="fechaHoraSalida"
                            name="fechaHoraSalida"
                            value={formData.fechaHoraSalida}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-8 mt-2">
                        <label htmlFor="fechaHoraRegreso" className="form-label">Fecha y Hora de Regreso</label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="fechaHoraRegreso"
                            name="fechaHoraRegreso"
                            value={formData.fechaHoraRegreso}
                            onChange={handleChange}
                            min={formData.fechaHoraSalida}
                            required
                        />
                    </div>
                    <div className="col-md-8 mt-2">
                        <label htmlFor="tipo" className="form-label">Tipo de Pase</label>
                        <select
                            className="form-select"
                            id="tipo"
                            name="tipo"
                            value={formData.tipo}
                            onChange={handleChange}
                            required
                        >
                            <option value="">--Seleccionar--</option>
                            <option disabled value="Sanidad">Sanidad</option>
                            <option disabled value="Franco de Honor">Franco de Honor</option>
                            <option value="Tramites Administrativos">Trámites Administrativos</option>
                            <option disabled value="Permiso Especial">Permiso Especial</option>
                            <option value="Servicio Externo">Servicio Externo</option>
                            <option disabled value="Otro">Otro</option>
                        </select>
                    </div>
                    <div className="col-md-8 mt-2">
                        <label htmlFor="observacion" className="form-label">Observación</label>
                        <input
                            type="text"
                            className="form-control"
                            id="observacion"
                            name="observacion"
                            value={formData.observacion}
                            onChange={handleChange}
                            placeholder="Observación (opcional)"
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-center mt-4">
                    <button
                        type="submit"
                        className="btn btn-primary me-2"
                        disabled={isLoading || formData.cadetesDni.length === 0}
                    >
                        {isLoading ? 'Generando Pases...' : 'Crear Pases Grupales'}
                    </button>
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn btn-danger"
                        disabled={isLoading}
                    >
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    );
};

export default GeneraPaseSalidaGrupalForm;